import moment from 'moment'
import pedidoService from '../../views/SofiaRei/FrenteDeCaixa/pedidoService'

export default {
    namespaced: true,
    state: {
      caixa: {},
      pedidos: [],
      despesas: [],
      // Atualiza lista de pedidos sempre que muda o valor de acordo 'filtro'
      atualizarPedidos: false,
      status: 'pendente',
      cxData: moment(new Date).format('YYYY-MM-DD'),
      saldo: null,
      tipoDeFiltro: null,
      mensalistas: [],
      filtro: {
        status: 'pendente',
        tipoServico: 'todos',
        data: '',
        numOs: '',
        solicitante: '',
        formaPg: '',
        caixaId: null,
        mensalistaId: null,
        loading: null,
        page: 1,
        lastPage: null,
        perPage: 20,
      },
    },
    mutations: {
      ATUALIZAR_DATA (state, payload) {
        state.pedidos = payload
      },
      ATUALIZAR_STATUS_PEDIDO (state, payload) {
        state.status = payload
        state.filtro.data = ''
        state.filtro.status = payload
        state.filtro.tipoServico = 'todos'
        state.filtro.numOs = ''
        state.filtro.solicitante = ''
        state.filtro.formaPg = ''
        state.filtro.page = 1
      },
      ATUALIZAR_CX_DATA (state, payload ) {
        state.cxData = payload
        state.filtro.data = ''
        state.filtro.tipoServico = 'todos'
        state.filtro.numOs = ''
        state.filtro.solicitante = ''
        state.filtro.formaPg = ''
        state.filtro.page = 1
      },
      ATUALIZAR_TIPO_DE_FILTRO (state, payload) {
        state.tipoDeFiltro = payload
      },
      ATUALIZAR_SALDO (state, payload) {
        state.saldo = payload
      },
      ATUALIZAR_MENSALISTA (state, payload) {
        state.mensalistas = payload
      },
      ATUALIZAR_CAIXA (state, payload) {
        state.caixa = payload
        state.filtro.caixaId = payload.caixa_id
      },
      ATUALIZAR_FILTRO (state, payload) {
        state.filtro[payload.tipo] = payload.value
      },
      ATUALIZAR_PEDIDOS (state) {
        //Sempre que muda o valor é refeito o get dos pedidos, saldo e despesas
        state.atualizarPedidos = !state.atualizarPedidos
      },
      ATUALIZAR_DESPESAS (state, payload) {
        state.despesas = payload
      }
    },
    actions: {
      getPedidos (context, payload) {
        context.commit('ATUALIZAR_DATA', payload)
      },
      atualizarStatus (context, payload) {
        context.commit('ATUALIZAR_STATUS_PEDIDO', payload)
      },
      atualizarCxData (context, payload) {
        context.commit('ATUALIZAR_CX_DATA', payload)
      },
      atualizarTipoDeFiltro (context, payload) {
        context.commit('ATUALIZAR_TIPO_DE_FILTRO', payload)
      },
      atualizarSaldo (context, payload) {
        context.commit('ATUALIZAR_SALDO', payload)
      },
      atualizarMensalistas (context, payload) {
        context.commit('ATUALIZAR_MENSALISTA', payload)
      },
      atualizarCaixa (context, payload) {
        context.commit('ATUALIZAR_CAIXA', payload)
      },
      atualizarFiltro (context, payload) {
        context.commit('ATUALIZAR_FILTRO', payload)
      },
      atualizarPedidos (context) {
        context.commit('ATUALIZAR_PEDIDOS')
      },
      atualizaDespesas (context, payload) {
        context.commit('ATUALIZAR_DESPESAS', payload)
      }
    }
  }
  